import { render } from "./add-company-list-modal.vue?vue&type=template&id=6d67d522"
import script from "./add-company-list-modal.vue?vue&type=script&lang=js"
export * from "./add-company-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__